import { useState, useEffect } from "react";
import GeneratingLoader from "../../../CommonElements/GeneratingLoader/GeneratingLoader"
import { getReportData } from "../../../Api/report";
import { useParams } from 'react-router-dom';
import ADHDPreviewTemplate from "./ADHDPreview";
import ASDPreviewTemplate from "./ASDPreview";
import { FormGroup, Button } from "reactstrap";
import { downloadReportPDF, onlyDownloadReportPDF } from "../../../Api/report";
import { getImage } from "../../../Api/report";
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import SendEmailModal from "./SendEmailModal";
import moment from 'moment';
import { useAppSelector } from "../../../ReduxToolkit/Hooks";

const GenerateDocPreview = () => {
  const { report_id } = useParams();
  const navigate = useNavigate();
  const user = useAppSelector(state => state.user)
  const [loader, setLoader] = useState<boolean>(false);
  const [showEmailModal, setShowEmailModal] = useState(false)
  const [template, setTemplate] = useState("")
  const [patient, setPatient] = useState<any>(null)
  const [content, setContent] = useState<any>(null)

  const [logoUrl, setLogoUrl] = useState("")
  const [logoWidth, setLogoWidth] = useState(0)
  const [logoHeight, setLogoHeight] = useState(0)

  const [signUrl, setSignUrl] = useState("")
  const [signWidth, setSignWidth] = useState(0)
  const [signHeight, setSignHeight] = useState(0)

  useEffect(() => {
    const fetchReport = async () => {
      const response: any = await getReportData({ report_id: report_id })
      setTemplate(response?.data.type)

      setPatient(response?.data.patient)
      setContent(response?.data.content)
      const getImages = []
      if (response?.data.content.logoId !== "") {
        getImages.push(getImage({ imageId: response?.data.content.logoId }))
      }
      if (response?.data.content.signId !== "") {
        getImages.push(getImage({ imageId: response?.data.content.signId }))
      }
      if (getImage.length > 0) {
        let results = await Promise.all(getImages);
        if (results.length && results[0]) {
          const logoData: any = results.filter((item: any) => item.type === "logo")[0]
          const signData: any = results.filter((item: any) => item.type === "sign")[0]
          if (logoData) {
            setLogoUrl(logoData.imageUrl)
            setLogoHeight(logoData.height)
            setLogoWidth(logoData.width)
          }
          if (signData) {
            setSignUrl(signData.imageUrl)
            setSignWidth(signData.width)
            setSignHeight(signData.height)
          }
        }
      }
    }

    fetchReport()
  }, [])

  const downloadReport = async () => {
    const response: any = await onlyDownloadReportPDF({ report_id: report_id })
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const a = document.createElement('a');
    a.href = url;
    const formattedTime = moment().format('YYYY-MM-DD_HH-mm-ss');
    a.download = `report_${formattedTime}.pdf`; // Suggest file name
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }

  const handleBack = () => {
    navigate(`/patient/report_generate?patient_id=${patient.id}&from=${report_id}`)
  }

  const handleNewReport = () => {
    navigate(`/patient/report_generate?patient_id=${patient.id}`)
  }

  const handleSendEmail = async () => {
    const response: any = await downloadReportPDF({ report_id: report_id })
    if (response.status) {
      setShowEmailModal(false)
      toast.success("The report has been successfully generated as PDF!")
    }
  }

  return (
    <div className="page-body">
      {loader && <GeneratingLoader label="Loading..." />}
      <FormGroup className="mb-0 form-sub-title d-flex justify-content-end gap-3" style={{ maxWidth: "1024px", margin: "0px auto" }}>
        {
          user?.role !== 'admin' && <div className="text-end" style={{ width: "120px" }}>
            <Button color="secondary" block style={{ padding: "12px 0px" }} onClick={handleNewReport}>
              {"New Report"}
            </Button>
          </div>
        }
        {
          user?.role !== 'admin' && <div className="text-end" style={{ width: "120px" }}>
            <Button color="primary" block style={{ padding: "12px 0px" }} onClick={handleBack}>
              {"Go to Edit"}
            </Button>
          </div>
        }
        <div className="text-end" style={{ width: "120px" }}>
          <Button color="secondary" block style={{ padding: "12px 0px" }} onClick={() => setShowEmailModal(true)}>
            {"Send Email"}
          </Button>
        </div>
        <div className="text-end" style={{ width: "120px" }}>
          <Button color="primary" block style={{ padding: "12px 0px" }} onClick={downloadReport}>
            {"Download"}
          </Button>
        </div>
      </FormGroup>
      <div className="bg-white px-5 pt-5 mb-5" style={{ maxWidth: "1024px", margin: "0px auto", borderRadius: "10px", paddingBottom: "60px" }}>
        {
          template === "adhd" &&
          <ADHDPreviewTemplate
            patient={patient}
            fullName={`${user.firstname} ${user.lastname}`}
            content={content}
            logoUrl={logoUrl}
            logoWidth={logoWidth}
            logoHeight={logoHeight}
            signUrl={signUrl}
            signWidth={signWidth}
            signHeight={signHeight}
          />
        }
        {
          template === "asd" &&
          <ASDPreviewTemplate
            patient={patient}
            fullName={`${user.firstname} ${user.lastname}`}
            content={content}
            logoUrl={logoUrl}
            logoWidth={logoWidth}
            logoHeight={logoHeight}
            signUrl={signUrl}
            signWidth={signWidth}
            signHeight={signHeight}
          />
        }
      </div>
      <SendEmailModal
        modal={showEmailModal}
        setModal={() => setShowEmailModal(false)}
        patient={patient}
        handleSendEmail={handleSendEmail}
      />
    </div>
  )
}

export default GenerateDocPreview;